export const devTabOptions = [
    { label: 'Dashboard', icon: 'assets/images/layout.png', route: '/dashboard',enabled:false },
    { label: 'Explore', icon: 'assets/images/search.png', route: '/chat-board',enabled:true},
    { label: 'Insights', icon: 'assets/images/knowledge.png', route: '/insights',enabled:false },
  
   
  ];